import React, { useEffect } from 'react';
import { Sparkles, X } from 'lucide-react';
import { RealtimeToast } from '../../services/realtime.ts';

interface RealtimeToastsProps {
  toasts: RealtimeToast[];
  onDismiss: (id: string) => void;
}

export const RealtimeToasts: React.FC<RealtimeToastsProps> = ({ toasts, onDismiss }) => {
  useEffect(() => {
    if (toasts.length === 0) return;
    const oldest = toasts[toasts.length - 1];
    const timer = setTimeout(() => {
      onDismiss(oldest.id);
    }, 4500);

    return () => clearTimeout(timer);
  }, [toasts, onDismiss]);

  if (toasts.length === 0) return null;

  return (
    <div className="realtime-toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className="realtime-toast">
          <div className="toast-icon-wrapper">
            <Sparkles size={15} />
          </div>
          <div className="toast-body">
            <span className="toast-user">{toast.user || 'Collaborator'}</span>
            <span className="toast-msg">{toast.message}</span>
          </div>
          <button className="toast-close-btn" onClick={() => onDismiss(toast.id)}>
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};
